import {  } from "helpers/url_helper";

import{
GET_CORALOGIX_SUBSYSTEMS,
GET_CORALOGIX_SUBSYSTEMS_FAIL,
GET_CORALOGIX_SUBSYSTEMS_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
    subsystems: [],
    error: null,
};

const Coralogix = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CORALOGIX_SUBSYSTEMS:
            return {
                ...state,
            };
        case GET_CORALOGIX_SUBSYSTEMS_SUCCESS:
            return {
                ...state,
                subsystems: action.payload,
            };
        case GET_CORALOGIX_SUBSYSTEMS_FAIL:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
}

export default Coralogix;